module.exports = __webpack_public_path__ + "img/filtro.0d378981.svg";